module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "left": "",
      "min-width": "10rem",
      "offset-y": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-btn', {
    staticStyle: {
      "margin-right": "0"
    },
    attrs: {
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    class: _vm.textClass
  }, [_vm._v("print")])], 1), _vm._v(" "), _c('span', {
    class: _vm.textClass
  }, [_vm._v(_vm._s('Печать'))])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((this.actions), function(action) {
    return [(action.divider) ? _c('v-divider') : _c('v-list-tile', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (action.isVisible()),
        expression: "action.isVisible()"
      }],
      key: action.caption(),
      on: {
        "click": function($event) {
          return action.run()
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(action.caption()))])], 1)]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-094b63eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/PrintBtn.vue
// module id = 856
// module chunks = 1